import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "d-flex flex-row fl-j-c spinner"
};

var _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"loader\"><svg viewBox=\"0 0 120 120\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"load one\" cx=\"60\" cy=\"60\" r=\"40\"></circle><circle class=\"load two\" cx=\"60\" cy=\"60\" r=\"40\"></circle><circle class=\"load three\" cx=\"60\" cy=\"60\" r=\"40\"></circle><g><circle class=\"point one\" cx=\"45\" cy=\"70\" r=\"5\"></circle><circle class=\"point two\" cx=\"60\" cy=\"70\" r=\"5\"></circle><circle class=\"point three\" cx=\"75\" cy=\"70\" r=\"5\"></circle></g></svg></div>", 1);

var _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}